import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import GameCreator from './GameCreator';
import PhoneMockup from './PhoneMockup';
import WheelGame from './WheelGame';
import { FadeIn, CountUp, GoogleG } from './lp/Motion';
import './LandingPage.css';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const CTA = ({ className = '', large = false }) => (
  <button
    type="button"
    className={`lp-btn lp-btn-primary ${large ? 'lp-btn-large' : ''} ${className}`.trim()}
    onClick={() => scrollTo('create-game')}
  >
    Créer mon jeu gratuitement
  </button>
);

const SectionCta = () => (
  <div className="lp-section-cta">
    <CTA />
    <p className="lp-hint">15 jours offerts · Sans CB · Résiliation 1 clic</p>
  </div>
);

const LandingPage = () => {
  const [zoomSrc, setZoomSrc] = useState(null);

  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.scrollTo(0, 0);
  }, []);

  const flyerImages = [
    'flyer1.jpg', 'flyer2.jpg', 'flyer3.png', 'flyer4.png', 'flyer6.png',
    'flyer7.jpg', 'flyer8.jpg', 'flyer9.jpg', 'flyer10.jpg', 'flyer11.jpg',
    'flyer12.jpg', 'flyer13.jpg',
  ];

  const beforeAfterImages = [
    'avantapres1.jpg', 'avantapres2.jpg', 'avantapres4.jpg', 'avantapres5.jpg',
    'avantapres6.jpg', 'avantapres7.png', 'avantapres8.png', 'avantapres9.png',
    'avantapres10.png', 'avantapres11.png', 'avantapres12.png', 'avantapres3.jpg',
  ];

  const reviews = [
    {
      initials: 'MH',
      name: 'Medin Hadza',
      time: 'il y a 4 mois',
      text: "Honnêtement j'étais pas trop à l'idée de ce genre de fonctionnement pour avoir des avis mais faut l'avouer que en une demi journée j'ai fais autant d'avis que seul en 2 ans merci encore ❤️",
    },
    {
      initials: 'DP',
      name: 'DolcePizzaCrepy',
      time: 'il y a 5 mois',
      text: "Parfait au top ! Super travail. Tres reactif et a l'écoute attentive des besoins. Nous recommandons a tout nouveaux candidat. Bonne continuation heypulse !!!",
    },
    {
      initials: 'PB',
      name: 'Pizza Bueno',
      time: 'il y a 6 mois',
      text: "Les services proposer sont vraiment top et simple d'utilisation ! Le patron très sympathique, je recommande fortement !",
    },
    {
      initials: 'GK',
      name: 'giustiniani kevin',
      time: 'il y a 6 mois',
      text: 'Hyper sérieux ! Super rapide et à l\'écoute 😉 Je recommande vraiment !',
    },
  ];

  return (
    <div className="lp-root">
      <Header />

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-hero-mesh" aria-hidden="true" />
        <div className="lp-hero-grid">
          <div className="lp-hero-copy">
            <FadeIn>
              <div className="lp-hero-chip">
                <GoogleG size={16} />
                <span className="lp-stars">★★★★★</span>
                <strong>5,0</strong>
                <span className="lp-dot">·</span>
                <span>+50 avis Google</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.06}>
              <h1 className="lp-hero-title">
                Chaque client satisfait devient un <em>avis Google</em>
              </h1>
            </FadeIn>

            <FadeIn delay={0.12}>
              <p className="lp-hero-subtitle">
                QR → mini-jeu → avis. Automatique. Sans former votre équipe.
              </p>
            </FadeIn>

            <FadeIn delay={0.18}>
              <div className="lp-hero-cta">
                <CTA large />
                <button type="button" className="lp-btn lp-btn-ghost" onClick={() => scrollTo('demo')}>
                  Voir la démo
                </button>
              </div>
              <p className="lp-hero-fineprint">Aucune carte bancaire · Essai 15 jours · Arrêt immédiat</p>
            </FadeIn>

            <FadeIn delay={0.24}>
              <div className="lp-hero-stats">
                <div>
                  <strong><CountUp end={1000} suffix="+" /></strong>
                  <span>commerces</span>
                </div>
                <div>
                  <strong className="lp-flag" aria-label="France">
                    <svg viewBox="0 0 3 2" width="22" height="14" aria-hidden="true">
                      <rect width="1" height="2" x="0" fill="#002395" />
                      <rect width="1" height="2" x="1" fill="#fff" />
                      <rect width="1" height="2" x="2" fill="#ED2939" />
                    </svg>
                  </strong>
                  <span>Conçu en France</span>
                </div>
                <div>
                  <strong>5,0★</strong>
                  <span>note Google</span>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.15} className="lp-hero-stage" y={36}>
            <div className="lp-stage-frame">
              <PhoneMockup className="phone-mockup--hero lp-stage-desktop">
                <WheelGame
                  prizes={['Dessert offert', 'Café gratuit', 'Frites']}
                  logo="logo-jeu.png"
                  centerSrc="center.png"
                  background="#ffffff"
                  accent="#004068"
                  businessName="One Burger Two Burger"
                  message="PARTICIPEZ À NOTRE JEU ET TENTEZ DE GAGNER UN CADEAU !"
                />
              </PhoneMockup>

              <img
                className="lp-stage-mobile"
                src="etape3.gif"
                alt="Aperçu du jeu de la roue HeyPulse"
                loading="lazy"
                decoding="async"
              />

              <div className="lp-float lp-float-review">
                <GoogleG size={14} />
                <div>
                  <strong>+1 avis Google</strong>
                  <span>il y a 2 min</span>
                </div>
              </div>

              <div className="lp-float lp-float-stars">
                <span className="lp-stars">★★★★★</span>
                <strong>5,0</strong>
              </div>

              <div className="lp-float lp-float-dash">
                <span className="lp-float-dash-label">Dashboard</span>
                <strong>+127 avis</strong>
                <em>ce mois-ci</em>
              </div>

              <div className="lp-float lp-float-ticket">
                <span>QR</span>
                <div>
                  <strong>Jeu de la roue</strong>
                  <em>Scan → jouer</em>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* SOCIAL STRIP */}
      <section className="lp-strip">
        <FadeIn className="lp-strip-inner">
          <p>Ils collectent déjà des avis avec HeyPulse</p>
          <div className="lp-strip-metrics">
            <div><CountUp end={1000} suffix="+" /> <span>commerces</span></div>
            <div><CountUp end={500} suffix="k+" /> <span>parties</span></div>
            <div><CountUp end={50} suffix="+" /> <span>avis HeyPulse</span></div>
            <div>5,0★ <span>Google</span></div>
          </div>
        </FadeIn>
      </section>

      {/* PROBLEM */}
      <section className="lp-problem">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Le vrai frein</div>
            <h2 className="lp-h2">Vos clients sont contents. <em>Google ne le sait pas.</em></h2>
            <p className="lp-lead">Ce n&apos;est pas la qualité qui manque — c&apos;est le moment de demander l&apos;avis.</p>
          </FadeIn>

          <div className="lp-bento">
            <FadeIn className="lp-bento-card" delay={0.05}>
              <div className="lp-bento-stat">98%</div>
              <h3>lisent les avis avant d&apos;entrer</h3>
              <p>Trop peu d&apos;avis ou une note moyenne, et le client choisit le voisin.</p>
              <span className="lp-source">IFOP / BrightLocal</span>
            </FadeIn>
            <FadeIn className="lp-bento-card" delay={0.1}>
              <div className="lp-bento-stat">Top 3</div>
              <h3>captent les recherches Maps</h3>
              <p>Hors du trio de tête, votre fiche disparaît. Les avis récents aident à remonter.</p>
              <span className="lp-source">Search Engine Land · Moz</span>
            </FadeIn>
            <FadeIn className="lp-bento-card lp-bento-wide" delay={0.15}>
              <div className="lp-bento-stat">Le silence</div>
              <h3>Les contents se taisent. Les mécontents écrivent.</h3>
              <p>Sans invitation claire, le client content rentre chez lui. HeyPulse demande l&apos;avis juste après l&apos;expérience — téléphone encore en main.</p>
              <SectionCta />
            </FadeIn>
          </div>
        </div>
      </section>

      {/* HOW */}
      <section id="how" className="lp-how">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Comment ça marche</div>
            <h2 className="lp-h2">Trois gestes. <em>Zéro friction.</em></h2>
            <p className="lp-lead">Du scan au cadeau, moins de 30 secondes.</p>
          </FadeIn>

          <div className="lp-timeline">
            {[
              { n: '01', img: 'etape1.png', t: 'Le client scanne', d: 'QR sur flyer, ticket ou présentoir → page de jeu à vos couleurs.' },
              { n: '02', img: 'etape2.png', t: 'Il valide une action', d: 'Avis Google 5★, Instagram, TikTok… vous choisissez les actions utiles.' },
              { n: '03', img: 'etape3.gif', t: 'Il tourne la roue', d: 'Cadeau à récupérer en magasin — pour faire revenir vos clients.' },
            ].map((s, i) => (
              <FadeIn key={s.n} className="lp-timeline-item" delay={i * 0.08}>
                <div className="lp-timeline-media">
                  <img src={s.img} alt={s.t} loading="lazy" decoding="async" />
                </div>
                <div className="lp-timeline-body">
                  <div className="lp-timeline-num">{s.n}</div>
                  <h3>{s.t}</h3>
                  <p>{s.d}</p>
                </div>
              </FadeIn>
            ))}
          </div>
          <SectionCta />
        </div>
      </section>

      {/* RESULTS */}
      <section id="results" className="lp-results">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Résultats mesurables</div>
            <h2 className="lp-h2">
              <em>+3 000 avis</em> en 5 mois — La Baraka, Nantes
            </h2>
          </FadeIn>

          <FadeIn className="lp-metrics" delay={0.08}>
            <div className="lp-metric">
              <span>Avis Google</span>
              <strong><CountUp end={3000} suffix="+" /></strong>
              <em>cumulés</em>
            </div>
            <div className="lp-metric">
              <span>Note moyenne</span>
              <strong>4,6★</strong>
              <em>sur Maps</em>
            </div>
            <div className="lp-metric">
              <span>Joueurs</span>
              <strong><CountUp end={950} suffix="+" /></strong>
              <em>en 5 mois</em>
            </div>
            <div className="lp-metric">
              <span>Durée</span>
              <strong>5 mois</strong>
              <em>usage continu</em>
            </div>
          </FadeIn>

          <FadeIn className="lp-case-story" delay={0.12}>
            <div>
              <h3>Avant</h3>
              <p>8 à 12 avis / mois, au fil de l&apos;eau.</p>
            </div>
            <div>
              <h3>Mise en place</h3>
              <p>Flyer + QR en bas de ticket. Scan → action → roue.</p>
            </div>
            <div className="lp-case-hl">
              <h3>Après</h3>
              <p>Volume d&apos;avis multiplié, présence locale renforcée, clients qui reviennent.</p>
            </div>
          </FadeIn>
          <SectionCta />
        </div>
      </section>

      {/* BEFORE / AFTER */}
      <section className="lp-gallery">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Preuves terrain</div>
            <h2 className="lp-h2">Fiches Google <em>avant / après</em></h2>
            <p className="lp-lead">Captures observées chez nos commerçants</p>
          </FadeIn>
          <div className="lp-gallery-scroll">
            {beforeAfterImages.map((src, i) => (
              <button
                type="button"
                key={src}
                className="lp-gallery-item lp-gallery-item-result"
                onClick={() => setZoomSrc(src)}
              >
                <img src={src} alt={`Avant / Après ${i + 1}`} loading="lazy" decoding="async" />
              </button>
            ))}
          </div>
          <SectionCta />
        </div>
      </section>

      {/* REVIEWS */}
      <section id="reviews" className="lp-testimonials">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-rating-pill">
              <GoogleG size={22} />
              <strong>5,0</strong>
              <span className="lp-stars">★★★★★</span>
              <em>+50 avis Google</em>
            </div>
            <h2 className="lp-h2">Ils utilisent HeyPulse — <em>voici leurs retours</em></h2>
          </FadeIn>

          <div className="lp-review-grid">
            {reviews.map((r, i) => (
              <FadeIn key={r.name} className="lp-review-card" delay={i * 0.05}>
                <header>
                  <span className="lp-avatar">{r.initials}</span>
                  <div>
                    <strong>{r.name}</strong>
                    <div className="lp-review-meta">
                      <span className="lp-g-badge"><GoogleG size={11} /> Avis Google</span>
                      <em>{r.time}</em>
                    </div>
                  </div>
                </header>
                <div className="lp-stars">★★★★★</div>
                <p>{r.text}</p>
              </FadeIn>
            ))}
          </div>

          <a
            className="lp-reviews-more"
            href="https://www.google.com/search?q=HeyPulse+Reviews&rflfq=1&num=20&rldimm=17659030819447606604&tbm=lcl#lkt=LocalPoiReviews"
            target="_blank"
            rel="noreferrer"
          >
            Voir plus d&apos;avis
          </a>
          <SectionCta />
        </div>
      </section>

      {/* DEMO */}
      <section id="demo" className="lp-demo">
        <div className="lp-section-inner lp-section-narrow">
          <FadeIn>
            <div className="lp-eyebrow">Démo</div>
            <h2 className="lp-h2">Du QR à l&apos;avis — <em>en conditions réelles</em></h2>
            <p className="lp-lead">Voici une présentation rapide</p>
          </FadeIn>
          <FadeIn className="lp-video-wrap" delay={0.08}>
            <iframe
              src="https://www.youtube.com/embed/n2TQu3fthms"
              title="HeyPulse — Démo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </FadeIn>
          <SectionCta />
        </div>
      </section>

      {/* RESEARCH */}
      <section className="lp-research">
        <div className="lp-section-inner lp-section-narrow">
          <FadeIn>
            <div className="lp-eyebrow">Preuve externe</div>
            <h2 className="lp-h2">Une étoile de plus, c&apos;est du <em>chiffre d&apos;affaires</em></h2>
          </FadeIn>
          <FadeIn className="lp-quote" delay={0.08}>
            <div className="lp-quote-mark">H</div>
            <p>
              « Une augmentation d&apos;une étoile sur les plateformes d&apos;avis se traduit
              par une hausse de <strong>5 à 9%</strong> du CA des restaurants. »
            </p>
            <cite>Michael Luca · Harvard Business School · 2016</cite>
          </FadeIn>
          <div className="lp-numbers">
            <FadeIn className="lp-number" delay={0.05}><strong><CountUp end={1000} suffix="+" /></strong><span>commerces</span></FadeIn>
            <FadeIn className="lp-number" delay={0.1}><strong><CountUp end={500} suffix="k+" /></strong><span>parties</span></FadeIn>
            <FadeIn className="lp-number" delay={0.15}><strong>5,0★</strong><span>note Google</span></FadeIn>
            <FadeIn className="lp-number" delay={0.2}><strong>5 ans</strong><span>d&apos;expérience</span></FadeIn>
          </div>
        </div>
      </section>

      {/* FLYERS */}
      <section className="lp-flyers">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Supports print</div>
            <h2 className="lp-h2">Flyers à l&apos;image de votre enseigne</h2>
            <div className="lp-tags">
              <span>À votre image</span>
              <span>Création sous 48h</span>
              <span>Qualité impression</span>
            </div>
          </FadeIn>
          <div className="lp-gallery-scroll">
            {flyerImages.map((src, i) => (
              <button
                type="button"
                key={src}
                className="lp-gallery-item lp-gallery-item-flyer"
                onClick={() => setZoomSrc(src)}
              >
                <img src={src} alt={`Flyer ${i + 1}`} loading="lazy" decoding="async" />
              </button>
            ))}
          </div>
          <SectionCta />
        </div>
      </section>

      <GameCreator />

      {/* FIT */}
      <section className="lp-fit">
        <div className="lp-section-inner">
          <FadeIn>
            <div className="lp-eyebrow">Pour qui ?</div>
            <h2 className="lp-h2">HeyPulse est-il fait pour vous ?</h2>
          </FadeIn>
          <div className="lp-fit-grid">
            <FadeIn className="lp-fit-col lp-fit-yes">
              <h3>Oui, si vous…</h3>
              <ul>
                <li><strong>Recevez des compliments, peu d&apos;avis</strong><em>Les clients oublient Google.</em></li>
                <li><strong>Voulez un système sans briefer l&apos;équipe</strong><em>Le QR guide le client.</em></li>
                <li><strong>Investissez en local</strong><em>Vous savez qu&apos;une note Google impacte le CA.</em></li>
                <li><strong>Voulez aussi faire revenir</strong><em>Faites revenir vos clients pour qu’ils récupèrent leurs cadeaux.</em></li>
              </ul>
            </FadeIn>
            <FadeIn className="lp-fit-col lp-fit-no" delay={0.08}>
              <h3>Non, si vous…</h3>
              <ul>
                <li><strong>Cherchez de faux avis</strong><em>Refus. Contre Google et la loi.</em></li>
                <li><strong>Avez très peu de passage</strong><em>Sous ~20 clients/jour, levier limité.</em></li>
                <li><strong>Ne diffuserez pas le QR</strong><em>Un flyer oublié ne produit rien.</em></li>
                <li><strong>Attendez qu&apos;un outil masque un mauvais service</strong><em>HeyPulse amplifie le réel.</em></li>
              </ul>
            </FadeIn>
          </div>
          <SectionCta />
        </div>
      </section>

      {/* FAQ */}
      <section className="lp-faq">
        <div className="lp-section-inner lp-section-narrow">
          <FadeIn>
            <div className="lp-eyebrow">FAQ</div>
            <h2 className="lp-h2">Questions fréquentes</h2>
          </FadeIn>
          <div className="lp-faq-list">
            <FaqItem
              q="C'est quoi HeyPulse exactement ?"
              a="Un mini-jeu mobile (roue) relié à votre fiche Google et vos réseaux. Il aide vos clients réels à laisser un avis et à revenir. +1 000 commerces en France."
            />
            <FaqItem
              q="Que se passe-t-il côté client ?"
              a="Il scanne le QR, choisit une action, tourne la roue et reçoit un lot. Vous configurez tout depuis votre espace."
            />
            <FaqItem
              q="Est-ce compatible avec les règles Google ?"
              a="Oui. Pas de faux avis. Le jeu motive un client réel à publier son retour — respect Google et DGCCRF."
            />
            <FaqItem
              q="Quels résultats peut-on espérer ?"
              a="Selon le trafic et la diffusion du QR. Beaucoup passent de quelques avis/mois à plusieurs dizaines. Non garanti."
            />
            <FaqItem
              q="Je peux modifier les lots après ?"
              a="Oui, à tout moment dans le tableau de bord."
            />
            <FaqItem
              q="Comment arrêter ?"
              a="1 clic. 15 premiers jours gratuits, sans CB à l'inscription."
            />
          </div>
          <div className="lp-faq-cta">
            Une question ?
            <a href="https://wa.me/33789987906" target="_blank" rel="noreferrer">WhatsApp</a>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="lp-final-cta">
        <div className="lp-final-mesh" aria-hidden="true" />
        <FadeIn className="lp-final-inner">
          <h2>Votre prochain avis Google commence par un scan</h2>
          <p>Configurez votre jeu maintenant — prêt en quelques secondes.</p>
          <CTA large />
          <p className="lp-hint">Sans CB · Sans engagement · Arrêt immédiat</p>
        </FadeIn>
      </section>

      {zoomSrc && (
        <div className="lp-zoom-overlay" onClick={() => setZoomSrc(null)} role="presentation">
          <img src={zoomSrc} alt="Aperçu agrandi" />
        </div>
      )}

      <Footer />
    </div>
  );
};

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <button type="button" className={`lp-faq-item ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
      <div className="lp-faq-q">
        <span>{q}</span>
        <span className="lp-faq-icon" aria-hidden="true">{open ? '−' : '+'}</span>
      </div>
      {open && <div className="lp-faq-a">{a}</div>}
    </button>
  );
};

export default LandingPage;
